import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import FieldText from '@atlaskit/field-text';
import Form, { Field, FormSection, FormFooter } from '@atlaskit/form';
import SectionMessage from '@atlaskit/section-message';

// @source
import { fields } from '../../../../constants';
import { SchemaGenerator } from '../../../components';
import { Validation } from '../../../../tools';

const initialState = {
  message: false,
};

const initialStatic = {
  configuration: {},
  report: '',
};

class ReportInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.static = initialStatic;
    this.onClickContininue = this.onClickContininue.bind(this);
    this.setSchemaGeneratorConfig = this.setSchemaGeneratorConfig.bind(this);
  }

  onClickContininue(event) {
    event.preventDefault();
    const validate = this.form.validate();

    if (!validate.isInvalid) {
      const duplicate = this.checkDuplicateConfiguration();

      if (!duplicate) {
        this.props.update(this.static);
        this.props.setStep(1);
      }
    }
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  setSchemaGeneratorConfig(output) {
    this.setStatic({ configuration: output });
  }

  checkDuplicateConfiguration() {
    const { configuration } = this.static;

    for (let i = 0; i < configuration.length; i += 1) {
      const elem = configuration[i];
      const condition = configuration.filter(rule => (
        rule.cell === elem.cell && rule.row === elem.row
      ));
      if (condition.length > 1) {
        this.setState({
          message: (
            <div style={{ marginBottom: 15 }}>
              <SectionMessage appearance="warning">
                The same cell used more than one, please check and try again!
              </SectionMessage>
            </div>
          ),
        });
        return true;
      }
    }
    return false;
  }

  render() {
    return (
      <div style={{ display: this.props.current ? 'block' : 'none' }}>
        <Form
          name="configuration"
          onSubmit={this.onSubmitHandle}
          ref={(node) => { this.form = node; }}
        >
          <FormSection
            title="Report Name"
            description="Please enter the name of the report to be used anywhere. This name can be changed later."
          >
            <Field
              {...fields.defaults.field}
              name="report"
              validators={[Validation.required]}
            >
              <FieldText
                {...fields.defaults.fieldText}
                onChange={event => this.setStatic({ report: event.target.value })}
                value={this.static.report}
              />
            </Field>
          </FormSection>
          <FormSection
            title="Configuration"
            description="The report will be produced according to your settings."
          >
            <SchemaGenerator output={this.setSchemaGeneratorConfig} />
          </FormSection>
          <FormFooter>
            {this.state.message}
            <div style={{ textAlign: 'right' }}>
              <Button
                appearance="primary"
                onClick={this.onClickContininue}
                type="submit"
              >
                Continue
              </Button>
            </div>
          </FormFooter>
        </Form>
      </div>
    );
  }
}

ReportInformation.propTypes = {
  current: PropTypes.bool.isRequired,
  setStep: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
};

export default ReportInformation;
